module.exports = __webpack_public_path__ + "static/media/loginlogo.2f53cd44.svg";